module.exports = __webpack_public_path__ + "static/img/front.8f8de359.png";